/* global angular, Dropzone */
(function () {
  'use strict';

  angular.module('wsLrs.controllers').config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/admin', {
      templateUrl: 'modules/app/admin/admin.html',
      controller: 'AdminCtrl'
    }).when('/admin/:orgId', {
      templateUrl: 'modules/app/admin/organization.html',
      controller: 'AdminOrganizationEditCtrl'
    });
  }]).controller('AdminCtrl', ['$http', '$location', '$scope', 'Api', 'Job', 'User', 'UserRoles', function ($http, $location, $scope, Api, Job, User, UserRoles) {
    if (!UserRoles.isSystemAdmin(User.get())) {
      $location.path('/activity');
    }

    // Set the headline / nav bar
    $scope.$emit("headline:change", "Admin");
    $scope.$emit("nav:change", "admin");
    $scope.updateAllTenantDBs = Job.run($scope, Api.url("/admintools/update-tenant-dbs", true), 'upgradeAllJob');
    $scope.updateCentralDB = function () {
      $scope.updateCentral = true;
      $http.post(Api.url("/admintools/update-central-db", true)).then(function () {
        $scope.updateCentral = false;
      });
    };
    $scope.doAliasSync = function () {
      $scope.aliasSync = true;
      $http.post(Api.url("/elastic-tools/alias-sync", true)).then(function () {
        $scope.aliasSync = false;
      });
    };
  }]).
  /**
   * Admin Page
   */
  controller('AdminOrganizationsCtrl', ['$controller', '$scope', 'Api', function ($controller, $scope, Api) {
    $scope.sortControls = [{
      "title": "Name",
      "options": {
        "Ascending": "name",
        "Descending": "-name"
      }
    }];
    $scope.apiUrl = Api.url("/organizations", true);
    $scope.modalOptions = {
      templateUrl: "modules/app/admin/add-org-modal.html",
      controller: "AdminAddOrganizationCtrl",
      scope: $scope
    };
    $controller('ListerModalBaseCtrl', {
      $scope: $scope
    });
    $scope.$on("org-item-added", function (evt, newOrg) {
      $scope.$broadcast("item-added", newOrg);
    });
    $scope.$on("org-item-delete", function (evt, index) {
      $scope.$broadcast("item-delete", index);
    });
  }]).controller('AdminAddOrganizationCtrl', ['$controller', '$http', '$scope', '$uibModalInstance', 'Api', 'Config', 'Logger', 'User', 'Utils', 'Validation', function ($controller, $http, $scope, $uibModalInstance, Api, Config, Logger, User, Utils, Validation) {
    $scope.newOrg = {};
    $scope.sourceOrgId = null;
    var wsConfig = Config.get();
    if (wsConfig.defaultTemplateOrganizationId !== null && typeof wsConfig.defaultTemplateOrganizationId !== "undefined") {
      $http.get(Api.url("/organizations/" + wsConfig.defaultTemplateOrganizationId, true)).then(function (org) {
        $scope.searchTerm = org.data.name;
        $scope.copyExistingOrg(org.data);
      });
    }
    $scope.formErrors = null;
    $scope.options = {
      createDemosAccount: false
    };
    $scope.saving = false;
    $scope.message = null;
    $scope.searchApiUrl = Api.url("/organizations", true);
    $scope.searchBy = "name";
    $scope.formatSearchSuggestion = function (result) {
      return result.name;
    };
    $scope.mapSearchResults = function (data) {
      return data.results;
    };
    $controller('SearchBaseCtrl', {
      $scope: $scope
    });
    $scope.copyExistingOrg = function (selectedOrg) {
      selectedOrg = selectedOrg || {};
      $scope.sourceOrgId = selectedOrg.id;
      var newOrgName = $scope.newOrg.name || ""; // preserve new Org name
      angular.copy(selectedOrg, $scope.newOrg); // copy selected org into newOrg
      $scope.newOrg.name = newOrgName;
      $scope.newOrg.id = null; // remove unique keys in organization
      $scope.newOrg.urlName = null;
    };
    function getShortName() {
      var shortName = $scope.newOrg.name.replace(/\s+/g, '-').toLowerCase();
      return shortName.charAt(0).toUpperCase() + shortName.slice(1);
    }
    function getPassword() {
      var pw = getShortName();
      while (pw.length < 8) {
        pw = pw + pw;
      }
      pw = pw + Math.round(Math.random() * 10) + "!";
      return pw;
    }
    $scope.save = function () {
      $scope.formErrors = Validation.validate({
        "name": {
          "rules": {
            "required": true
          },
          "value": $scope.newOrg.name
        }
      });
      if ($scope.formErrors !== null) {
        return;
      }
      $scope.saving = true;
      $http.post(Api.url("/organizations", true), $scope.newOrg, {
        params: {
          referenceId: $scope.sourceOrgId
        }
      }).then(function (response) {
        $scope.newOrg.id = Utils.getIdFromCreatedResponse(response);
        if ($scope.sourceOrgId) {
          createDemosAccount.apply(this, arguments);
        } else {
          createDemosAccount.apply(this, arguments);
        }
      }, createOrganizationError);
    };
    function createDemosAccount() {
      if ($scope.options.createDemosAccount) {
        $scope.message = "Creating Demos account for organization " + $scope.newOrg.id + ".";
        $http.post(Api.url("/users", true), {
          name: $scope.newOrg.name + " Demos",
          username: getShortName(),
          password: getPassword(),
          email: getShortName() + '+' + User.get().user.email
        }).then(addDemosAccountToOrganization, createOrganizationError);
      } else {
        createOrganizationSuccess();
      }
    }
    function addDemosAccountToOrganization(response) {
      $scope.demosAccountID = Utils.getIdFromCreatedResponse(response);
      $http.post(Api.url("/memberships", true), {
        user: {
          id: $scope.demosAccountID
        },
        organization: {
          id: $scope.newOrg.id
        },
        role: "user"
      }).then(createOrganizationSuccess, createOrganizationError);
    }
    function createOrganizationSuccess() {
      $uibModalInstance.close(['org-item-added', $scope.newOrg]);
    }
    function createOrganizationError(response) {
      Logger.error("Error creating organization, response status " + response.status);
      $scope.createError = "There was an error creating the organization: " + response.data.message;
      $scope.saving = false;
    }
    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };
  }]).controller('AdminOrganizationItemCtrl', ['$controller', '$scope', 'Logger', '$location', 'User', function ($controller, $scope, Logger, $location, User) {
    $scope.deleteSuccessEvent = "org-item-delete";
    $scope.deleteError = function (response) {
      Logger.error("Error deleting organization " + $scope.item.id + ", response status " + response.status);
      $scope.deleteErrorMsg = "There was an error deleting the organization.";
    };
    $scope.goToOrgAdminPage = function (id) {
      if (typeof id === 'undefined') {
        $location.path("/admin/".concat(User.get().membership.organization.id));
      } else {
        $location.path("/admin/".concat(id));
      }
    };
    $controller('ListerItemCtrl', {
      $scope: $scope
    });
  }]).controller('AdminOrganizationEditCtrl', ['$http', '$q', '$routeParams', '$scope', 'Api', 'Validation', 'ConfirmModal', '$location', 'xsrf', 'OrganizationSettings', function ($http, $q, $routeParams, $scope, Api, Validation, ConfirmModal, $location, xsrf, OrganizationSettings) {
    var orgId = $routeParams.orgId;
    $scope.showAdvancedOptions = true;
    $scope.orgSettings = null;
    $scope.original = {};
    $scope.datePickerOptions = {
      'constrainInput': true,
      'dateFormat': 'yy-mm-dd',
      'separator': 'T',
      'timeFormat': 'HH:mm:ss',
      'timeSuffix': 'Z',
      'showSecond': true,
      'showMillisec': true
    };
    $scope.attributeTypeOptions = ["oauth_domain"];
    $scope.showDropzone = false;
    $scope.addNewAttribute = function addNewAttribute(attType) {
      $scope.orgSettings.attributes.push({
        "type": attType ? attType : $scope.attributeTypeOptions[0],
        "value": ""
      });
    };
    $scope.removeAttribute = function removeAttribute(a) {
      var attIndex = $scope.orgSettings.attributes.indexOf(a);
      $scope.orgSettings.attributes.splice(attIndex, 1);
    };
    function saveSuccess() {
      $scope.$broadcast("org-item-save");
      $scope.message = "Changes saved successfully.";
      $scope.messageClass = 'alert alert-success';
      resetEditingState();
    }
    function toggleShowDropzone() {
      $scope.showDropzone = !$scope.showDropzone;
    }
    $scope.createDropzone = function createDropzone() {
      toggleShowDropzone();

      // Only define once
      if ($scope.samlUploadDropzone) {
        return;
      }
      $scope.samlUploadDropzone = new Dropzone("div#x509-dropzone", {
        url: function url() {
          return Api.url("/organizations/" + $scope.newOrg.id + "/saml/configuration/x509", true);
        },
        method: "put",
        enctype: "multipart/form-data",
        headers: xsrf.getHeaders(),
        addRemoveLinks: true,
        dictInvalidFileType: "Files of this type are not accepted. Please select a txt file.",
        accept: function accept(file, done) {
          $scope.$safeApply(function () {
            $scope.dropzoneErrorMessage = null;
          });
          done();
        },
        error: function error(file, e) {
          $scope.$safeApply(function () {
            $scope.dropzoneErrorMessage = "Upload failed: " + (e.exceptionMessage || e);
          });
          $scope.samlUploadDropzone.removeFile(file);
        },
        complete: function complete(file) {
          if (file.status === "error") {
            //simple attempt at error display, only gets called on exceptions?
            try {
              $(file.previewElement).find('.dz-error-message').text(JSON.parse(file.xhr.response).exceptionMessage);
            } catch (e) {
              //ignore
            }
            return;
          }
          var r = JSON.parse(file.xhr.response);
          $scope.samlConfiguration.x509PublicKey = r.x509PublicKey;
          toggleShowDropzone();
          $scope.samlUploadDropzone.removeFile(file);
          $scope.$apply(); // Function is outside digest cycle, so it must be manually triggered.
          saveSuccess();
        },
        maxFilesize: 2048 // MB
      });
    };
    function resetEditingState() {
      $scope.saving = false;
      $http.get(Api.url("/organizations/" + orgId, true)).then(function getOrganizationSuccess(response) {
        $scope.newOrg = response.data;
        $scope.original.newOrg = angular.copy($scope.newOrg);

        // Set the headline / nav bar
        $scope.$emit("headline:change", $scope.newOrg.name);
        $scope.$emit("nav:change", "admin");
      });
      $http.get(Api.url("/organizations/" + orgId + "/settings", true)).then(function getOrgSettingsSuccess(response) {
        $scope.orgSettings = response.data;

        // Pretty print feature overrides
        if ($scope.orgSettings.featureOverrides) {
          var featureOverrides = JSON.parse($scope.orgSettings.featureOverrides);
          $scope.orgSettings.featureOverrides = JSON.stringify(featureOverrides, null, '\t');
        }
        if ($scope.orgSettings.credlyBadgesIntegrationSettings !== undefined) {
          var url = $scope.orgSettings.credlyBadgesIntegrationSettings.apiEndpoint;
          $scope.validCredlyUrl = url ? ensureCredlyHost(url) : false;
        }
        $scope.original.orgSettings = angular.copy($scope.orgSettings);
      });
      $http.get(Api.url("/organizations/" + orgId + "/saml/configuration", true)).then(function getSamlConfigurationSuccess(response) {
        $scope.samlConfiguration = response.data;
        $scope.original.samlConfiguration = angular.copy($scope.samlConfiguration);
      });
      $http.get(Api.url("/organizations/" + orgId + "/ipaas/configuration", true)).then(function getIpaasConfigurationSuccess(response) {
        $scope.ipaasConfiguration = response.data;
        $scope.original.ipaasConfiguration = angular.copy($scope.ipaasConfiguration);
      });
    }
    $scope.identityProviders = [{
      "id": "watershed",
      "name": "Watershed"
    }, {
      "id": "google",
      "name": "Google"
    }, {
      "id": "saml",
      "name": "SAML"
    }, {
      "id": "ipaas",
      "name": "iPaaS"
    }];

    // Presently we only support a single identity provider, but in the future this can be used to add
    // more to the list of available providers in orgSettings (check commit history for prior implementation)
    $scope.toggleIdProvider = function toggleIdProvider(providerId) {
      var idProviders = $scope.orgSettings.identityProviders || [],
        index = idProviders.indexOf(providerId);
      idProviders.splice(index, 1);
      idProviders.push(providerId);
      $scope.orgSettings.identityProviders = idProviders;
    };
    $scope.validCredlyUrl = false;
    function ensureCredlyHost(parseUrl) {
      var host = parseUrl.host;
      return host ? host.split(".").indexOf('credly') !== -1 && host.endsWith("credly.com") : false;
    }
    $scope.validateCredlyUrl = _.debounce($scope.$safeApply.bind($scope, function () {
      var apiEndpoint = $scope.orgSettings.credlyBadgesIntegrationSettings.apiEndpoint;
      var parseUrl = TinCan.Utils.parseURL(apiEndpoint, {});
      $scope.validCredlyUrl = ensureCredlyHost(parseUrl);
    }, 200), true);
    $scope.saveOrganization = function () {
      $scope.organizationFormErrors = Validation.validate({
        "name": {
          "rules": {
            "required": true
          },
          "value": $scope.newOrg.name
        },
        "imageUrl": {
          "rules": {
            "url": true
          },
          "value": $scope.newOrg.imageUrl
        },
        "logoutRedirectUrl": {
          "rules": {
            "url": true
          },
          "value": $scope.orgSettings.logoutRedirectUrl
        },
        "samlSsoServiceUrl": {
          "rules": {
            "url": true
          },
          "value": $scope.samlConfiguration.ssoServiceUrl
        },
        "samlAccountHomePage": {
          "rules": {
            "url": true
          },
          "value": $scope.samlConfiguration.accountHomePage
        },
        "ipaasServiceUrl": {
          "rules": {
            "url": true
          },
          "value": $scope.ipaasConfiguration.ipaasServiceUrl
        },
        "ipaasCustomerKey": {
          // if ipaas, this is required
          "rules": {
            "required": $scope.orgSettings.identityProviders.indexOf('ipaas') >= 0
          },
          "value": $scope.ipaasConfiguration.customerKey
        },
        "ipaasAccountHomePage": {
          "rules": {
            "url": true,
            "required": $scope.orgSettings.identityProviders.indexOf('ipaas') >= 0
          },
          "value": $scope.ipaasConfiguration.accountHomePage
        },
        "preferredEmailExtension": {
          "display": 'Email extension',
          "rules": {
            "required": false,
            "startsWith": '@',
            "emailExtensionList": true
          },
          "value": $scope.orgSettings.preferredEmailExtension
        }
      });
      if ($scope.organizationFormErrors !== null) {
        return;
      }

      // Ensure public key ends with a single newline
      if ($scope.samlConfiguration.x509PublicKey) {
        var key = $scope.samlConfiguration.x509PublicKey;
        $scope.samlConfiguration.x509PublicKey = key.trim() + "\n";
      }

      // Diff the previous and current settings
      $scope.diff = {};
      Object.keys($scope.original).map(function (key) {
        Object.keys($scope[key]).map(function (subKey) {
          var propertyHasChanged = !angular.equals($scope.original[key][subKey], $scope[key][subKey]);
          if (propertyHasChanged) {
            var before = $scope.original[key][subKey];
            var after = $scope[key][subKey];
            if (before === undefined) {
              before = "undefined";
            }
            if (after === undefined) {
              after = "undefined";
            }
            if (before.indexOf && before.indexOf("{") > -1) {
              before = JSON.parse(before);
            }
            if (after.indexOf && after.indexOf("{") > -1) {
              after = JSON.parse(after);
            }
            $scope.diff[subKey] = {
              before: before,
              after: after
            };
          }
        });
      });

      // Confirm changed settings are intended
      ConfirmModal.open($scope, {
        title: "Save Organization",
        body: "",
        confirm: function confirm() {
          // Save organization entity
          $http.put(Api.url("/organizations/" + $scope.newOrg.id, true), $scope.newOrg).then(function () {}, function saveOrganizationError(response) {
            return $q.reject("Error saving organization " + $scope.newOrg.id + ", response status " + response.status);
          })

          // Save organization settings
          .then(function () {
            return $http.put(Api.url("/organizations/" + $scope.newOrg.id + "/settings", true), $scope.orgSettings).then(function () {}, function saveOrgSettingsError(response) {
              return $q.reject("Error saving organization settings for org " + $scope.newOrg.id + ", response status " + response.status);
            });
          })

          // Save SAML configuration
          .then(function () {
            return $http.put(Api.url("/organizations/" + $scope.newOrg.id + "/saml/configuration", true), $scope.samlConfiguration).then(function saveSamlConfiguration() {}, function saveSamlConfigurationError(response) {
              return $q.reject("Error saving organization SAML configuration for org " + $scope.newOrg.id + ", response status " + response.status);
            });
          })

          // Save IPaaS configuration
          .then(function () {
            return $http.put(Api.url("/organizations/" + $scope.newOrg.id + "/ipaas/configuration", true), $scope.ipaasConfiguration).then(function saveIpaasConfiguration() {}, function saveIpaasConfigurationError(response) {
              return $q.reject("Error saving organization IPaaS configuration for org " + $scope.newOrg.id + ", response status " + response.status);
            });
          })

          // Final success / error handling
          .then(saveSuccess, function saveError(reason) {
            $scope.message = "There was an error saving the organization.";
            if (reason) {
              $scope.message = $scope.message + " " + reason;
            }
            $scope.messageClass = 'alert alert-danger';
          });
        }
      }, {
        templateUrl: "modules/app/admin/edit-org-confirm.html",
        size: 'lg'
      });
    };
    $scope.deleteOrganization = function () {
      $http.delete('/api/organizations/' + $scope.newOrg.id).then(function () {
        $location.path('/admin');
      }, function (err) {
        $scope.deleteError = err.message;
      });
    };
    $scope.ssoSharesEnabled = OrganizationSettings.hasFeature("ssoShares");
    resetEditingState();
  }]).controller('AdminUsersCtrl', ['$controller', '$scope', 'Api', 'Alerts', '$http', function ($controller, $scope, Api, Alerts, $http) {
    $scope.sortControls = [{
      "title": "Name",
      "options": {
        "Ascending": "name",
        "Descending": "-name"
      },
      "colspan": 2
    }, {
      "title": "Email",
      "options": {
        "Ascending": "email",
        "Descending": "-email"
      }
    }, {}];
    $scope.defaultSearchBy = ["name", "email"];
    $scope.apiUrl = Api.url("/users", true);
    $scope.modalOptions = {
      templateUrl: "modules/app/admin/add-user-modal.html",
      controller: "AdminAddUserCtrl",
      scope: $scope
    };
    $scope.roles = [{
      name: "watershed-partner",
      description: "Watershed Partner"
    }];
    $scope.deleteUser = function (user) {
      $http.delete('/api/users/' + user.id).then(function () {
        $scope.currentListing = $scope.currentListing.filter(function (item) {
          return item.id !== user.id;
        });
        Alerts.raiseAlert({
          type: "success",
          text: "Successfully deleted " + user.name
        });
      }, function (err) {
        $scope.deleteErrorMsg = err.message;
      });
    };
    $scope.$on("org-people-item-added", function (evt, newUser) {
      $scope.$broadcast('item-added', newUser);
    });
    $scope.$on("org-people-item-delete", function (evt, index) {
      $scope.$broadcast('item-delete', index);
    });
    $controller('ListerModalBaseCtrl', {
      $scope: $scope
    });
  }]).controller('AdminUserBaseCtrl', ["$scope", function ($scope) {
    $scope.toggleRole = function toggleRole(roleName) {
      var idx = $scope.newUser.roles.indexOf(roleName);
      if (idx > -1) {
        $scope.newUser.roles.splice(idx, 1);
      } else {
        $scope.newUser.roles.push(roleName);
      }
    };
  }]).controller('AdminAddUserCtrl', ['$controller', '$http', '$scope', '$uibModalInstance', 'Api', 'Logger', 'Utils', 'Validation', function ($controller, $http, $scope, $uibModalInstance, Api, Logger, Utils, Validation) {
    $scope.showAdvancedOptions = true;
    $scope.readonly = false;
    $scope.newUser = {
      generateAnalyticsStatements: false
    };
    $scope.newUser.roles = [];
    $scope.searchApiUrl = Api.url("/users", true);
    $scope.searchBy = ["name", "email"];
    $controller('AdminUserBaseCtrl', {
      $scope: $scope
    });
    $scope.formatSearchSuggestion = function (result) {
      return result.name;
    };
    $scope.mapSearchResults = function (data) {
      return data.results;
    };
    $controller('SearchBaseCtrl', {
      $scope: $scope
    });
    $scope.copyExistingUser = function (selectedUser) {
      angular.copy(selectedUser, $scope.newUser);
      $scope.readonly = true;
    };
    $scope.timezoneNames = moment.tz.names();
    $scope.clearUserTimeZone = function () {
      $scope.newUser.timezone = null;
    };
    $scope.save = function () {
      $scope.addUserError = null;
      $scope.addUserProgress = null;
      if ($scope.newUser.id) {
        addToOrganization();
      } else {
        $scope.userFormErrors = Validation.validate({
          "name": {
            "rules": {
              "required": true
            },
            "value": $scope.newUser.name
          },
          "email": {
            "rules": {
              "required": true,
              "email": true
            },
            "value": $scope.newUser.email
          },
          "username": {
            "rules": {},
            "value": $scope.newUser.username
          },
          "password": {
            "rules": {
              "required": true,
              "password": true
            },
            "value": $scope.newUser.password
          },
          "verifyPassword": {
            "display": "Verify password",
            "rules": {
              "required": true,
              "matches": "password"
            },
            "value": $scope.newUser.verifyPassword
          }
        });
        if ($scope.userFormErrors !== null) {
          return;
        }
        $scope.sending = true;
        $scope.addUserProgress = "Adding " + $scope.newUser.name + "...";
        $http.post(Api.url("/users", true), {
          name: $scope.newUser.name,
          email: $scope.newUser.email,
          password: $scope.newUser.password,
          username: $scope.newUser.username || $scope.newUser.email,
          roles: $scope.newUser.roles,
          generateAnalyticsStatements: $scope.newUser.generateAnalyticsStatements
        }).then(function addUserSuccess(response) {
          // Keep the url around in case we need to delete with the PK right after adding.
          $scope.newUser.id = Utils.getIdFromCreatedResponse(response);
          addToOrganization();
        }, function addUserError(response) {
          $scope.addUserProgress = null;
          Logger.error("Error adding user " + $scope.newUser.email + ", response status " + response.status);
          if (response.status === 409) {
            $scope.addUserError = "This user already exists.";
          } else {
            $scope.addUserError = response.data.message;
          }
          $scope.sending = false;
        });
      }
    };
    function addToOrganization() {
      if ($scope.addToOrganization === true) {
        $scope.newMembership = {
          organization: $scope.newOrg,
          user: $scope.newUser,
          role: $scope.newUser.role
        };
        $http.post(Api.url("/memberships/", true), $scope.newMembership).then(function saveUserSuccess(response) {
          $scope.newMembership.id = Utils.getIdFromCreatedResponse(response);
          saveUserFinished();
        }, function saveUserError(response) {
          Logger.error("Error saving user " + $scope.newUser.id + ", response status " + response.status);
          if (response.status === 409) {
            $scope.addUserError = "This user is already a part of " + $scope.newOrg.name;
          } else {
            $scope.addUserError = "There was an error saving the user.";
          }
        });
      } else {
        saveUserFinished();
      }
    }
    function saveUserFinished() {
      $scope.sending = false;
      $scope.addUserProgress = null;
      $uibModalInstance.close(['org-people-item-added', $scope.newUser]);
    }
    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };
  }]).controller('AdminUsersItemCtrl', ['$controller', '$scope', '$uibModal', 'Logger', '$http', 'Api', function ($controller, $scope, $uibModal, Logger, $http, Api) {
    $scope.getPostData = function () {
      return $scope.editCopy;
    };
    $scope.saveSuccessEvent = "org-people-item-save";
    $scope.saveErrorEvent = "org-people-item-save-error";
    $scope.deleteSuccessEvent = "org-people-item-delete";
    $scope.deleteError = function (response) {
      Logger.error("Error deleting user " + $scope.item.id + ", response status " + response.status);
      $scope.deleteErrorMsg = "There was an error deleting the user.";
    };
    $controller('ListerItemCtrl', {
      $scope: $scope
    });
    $scope.modalOptions = {
      templateUrl: "modules/app/admin/edit-user-modal.html",
      controller: "AdminEditUserCtrl",
      scope: $scope
    };
    $scope.edit = function () {
      $scope.newUser = angular.copy($scope.item);
      var modalInstance = $uibModal.open($scope.modalOptions);
      $http.get(Api.url("/users/" + $scope.newUser.id + "/memberships", true)).then(function (r) {
        $scope.newUser.orgs = r.data.results.map(function (membership) {
          return membership.organization.name;
        });
      });
      modalInstance.result.then(function () {
        angular.extend($scope.item, $scope.newUser);
        $scope.$broadcast.call($scope, 'item-save', $scope.newUser);
      });
    };
  }]).controller('AdminEditUserCtrl', ['$controller', '$http', '$scope', '$uibModalInstance', 'Api', 'Logger', 'Validation', 'Alerts', 'User', '$location', function ($controller, $http, $scope, $uibModalInstance, Api, Logger, Validation, Alerts, User, $location) {
    $scope.showAdvancedOptions = true;
    $scope.readonly = false;
    $scope.apiUrl = Api.url("/users", true);
    $controller('AdminUserBaseCtrl', {
      $scope: $scope
    });
    $scope.timezoneNames = moment.tz.names();
    $scope.clearUserTimeZone = function () {
      $scope.newUser.timezone = null;
    };
    $scope.save = function () {
      $scope.saveUserError = null;
      $scope.saveUserProgress = null;
      $scope.userFormErrors = Validation.validate({
        "name": {
          "rules": {
            "required": true
          },
          "value": $scope.newUser.name
        },
        "email": {
          "rules": {
            "required": true,
            "email": true
          },
          "value": $scope.newUser.email
        },
        "username": {
          "rules": {},
          "value": $scope.newUser.username
        },
        "password": {
          "rules": {
            "required": false,
            "password": true
          },
          "value": $scope.newUser.password
        },
        "verifyPassword": {
          "rules": {
            "matches": "password"
          },
          "value": $scope.newUser.verifyPassword
        }
      });
      if ($scope.userFormErrors !== null) {
        return;
      }
      $scope.sending = true;
      $scope.saveUserProgress = "Saving " + $scope.newUser.name + "...";
      $http.put($scope.createItemUrl($scope.updateApiUrl), $scope.newUser).then(function () {
        Alerts.raiseAlert({
          type: "success",
          text: "Successfully saved " + $scope.newUser.name
        });
        $uibModalInstance.close([$scope.saveSuccessEvent, $scope.newUser]);
      }, function (response) {
        Logger.error("Error saving user, response status " + response.status);
        $scope.saveUserError = "There was an error saving the user: " + response.data.message;
        $scope.sending = false;
        $scope.saveUserProgress = null;
      });
    };
    $scope.loginAs = function (user) {
      $http.post(Api.url("/login/as/" + user.id, true)).then(function (res) {
        User.set(res.data);
        $location.path("/orgs");
        $uibModalInstance.dismiss();
      }).catch(function (err) {
        Logger.error('Error logging in as other user: ' + JSON.stringify(err));
      });
    };
    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };
    $scope.$watch('roles', function (newVal) {
      newVal.forEach(function (role) {
        if (role.add) {
          if ($scope.newUser.roles.indexOf(role.name) === -1) {
            $scope.newUser.roles.push(role.name);
          }
        } else {
          $scope.newUser.roles = $scope.newUser.roles.filter(function (existingRole) {
            return existingRole !== role.name;
          });
        }
      });
    }, true);
  }]).controller('AdminMembershipsCtrl', ['$controller', '$routeParams', '$scope', 'Api', 'User', 'UserRoles', function ($controller, $routeParams, $scope, Api, User, UserRoles) {
    $scope.modalOptions = {
      templateUrl: "modules/app/admin/add-user-modal.html",
      controller: "AdminAddUserCtrl",
      scope: $scope
    };
    var orgId = $routeParams.orgId;
    $scope.getApiUrl = Api.url("/organizations/" + orgId + "/memberships", true);
    $controller('UsersListerCtrl', {
      $scope: $scope
    });
    $scope.hideAddModalButton = false;
    $scope.addToOrganization = true;
    $scope.showExisting = true;
    $scope.availableRoles = UserRoles.getAllRoles(User.get());
    $scope.roleName = _.object(_.pluck($scope.availableRoles, 'id'), _.pluck($scope.availableRoles, 'name'));
  }]).controller('AdminTasksCtrl', ['$controller', '$http', '$routeParams', '$scope', '$timeout', 'Api', 'Config', 'Job', function ($controller, $http, $routeParams, $scope, $timeout, Api, Config, Job) {
    var orgId = $routeParams.orgId;
    $scope.referenceOrg = {};
    $scope.searchApiUrl = Api.url("/organizations", true);
    $scope.searchBy = "name";
    $scope.formatSearchSuggestion = function (result) {
      return result.name;
    };
    $scope.mapSearchResults = function (data) {
      return data.results;
    };
    $controller('SearchBaseCtrl', {
      $scope: $scope
    });
    $scope.copyExistingOrg = function (selectedOrg) {
      selectedOrg = selectedOrg || {};
      angular.copy(selectedOrg, $scope.referenceOrg);
    };
    var wsConfig = Config.get();
    if (wsConfig.defaultTemplateOrganizationId !== null && typeof wsConfig.defaultTemplateOrganizationId !== "undefined") {
      $http.get(Api.url("/organizations/" + wsConfig.defaultTemplateOrganizationId, true)).then(function (org) {
        $scope.searchTerm = org.data.name;
        $scope.copyExistingOrg(org.data);
      });
    }
    $scope.upgrade = Job.run($scope, Api.url("/admintools/update-tenant-dbs", true), 'upgradeJob', {
      organizationId: orgId
    });
    $scope.deleteAllData = function () {
      $scope.deleteJob = {};
      $scope.deleteJob.percentage = 10;
      $http.post(Api.url("/organizations/" + orgId + "/delete-data", true)).then(function () {
        $scope.syncLrsWithDelete();
        $scope.deleteJob.percentage = 100;
        $timeout(function () {
          $scope.deleteJob = null;
        }, 1000);
      });
    };
    $scope.reloadData = function () {
      if (orgId === $scope.referenceOrg.id.toString()) {
        return;
      }
      $scope.reloadJob = {};
      $scope.reloadJob.percentage = 0;
      $http.post(Api.url("/organizations/" + orgId + "/reload?referenceId=" + $scope.referenceOrg.id, true)).then(function () {
        $scope.reloadJob.percentage = 100;
        $timeout(function () {
          $scope.reloadJob = null;
        }, 1000);
      });
    };
    $scope.syncLrs = function () {
      $scope.lrsSyncJob = {};
      $scope.lrsSyncJob.percentage = 0;
      $http.post(Api.url("/elastic-tools/lrs-sync?tenantId=" + orgId, true)).then(function () {
        $scope.lrsSyncJob.percentage = 100;
        $timeout(function () {
          $scope.lrsSyncJob = null;
        }, 1000);
      });
    };
    $scope.rebuildMemberships = function () {
      $http.post(Api.url("/organizations/" + orgId + "/groups/rebuild-memberships-data", true));
    };
    $scope.backfillAccomplishments = function () {
      $http.post(Api.url("/admintools/backfill-accomplishment-entities?organizationId=" + orgId, true));
      $http.get(Api.url("/admintools/backfill-accomplishment-statements?tenantId=" + orgId, true));
    };
    $scope.syncLrsWithDelete = function () {
      $scope.lrsSyncDeleteJob = {};
      $scope.lrsSyncDeleteJob.percentage = 0;
      var job = angular.toJson({
        clearExistingStatements: true,
        batchSize: 1000
      });
      $http.post(Api.url("/elastic-tools/lrs-sync?tenantId=" + orgId, true), job).then(function () {
        $scope.lrsSyncDeleteJob.percentage = 100;
        $timeout(function () {
          $scope.lrsSyncDeleteJob = null;
        }, 1000);
      });
    };
    $scope.clearCache = function () {
      $scope.clearCacheJob = {};
      $scope.clearCacheJob.percentage = 0;
      $http.delete(Api.url("/cache")).then(function () {
        $scope.clearCacheJob.percentage = 100;
        $timeout(function () {
          $scope.clearCacheJob = null;
        }, 1000);
      });
    };
  }]).controller('AdminDashboardCopyCtrl', ['$controller', '$http', '$routeParams', '$scope', '$q', 'Api', function ($controller, $http, $routeParams, $scope, $q, Api) {
    // Init
    var orgId = parseInt($routeParams.orgId);
    $q.all([$http.get(Api.url("/organizations/" + orgId, true)), $http.get(Api.url("/organizations/" + orgId + "/dashboards?_limit=1000", true))]).then(function (responses) {
      $scope.org = responses[0].data;
      $scope.dashboards = responses[1].data.results;
    });
    $scope.resetEditingState = function resetEditingState() {
      $scope.fromDashboard = null;
      $scope.searchTerm = null;
      $scope.copyToOrg = null;
      $scope.copyOption = 'new';
      $scope.newDashboardName = null;
      $scope.targetDashboards = [];
      $scope.targetDashboard = null;
      $scope.complete = false;
      $scope.cardsCopied = 0;
      $scope.error = null;
    };
    $scope.resetEditingState();
    $scope.isValid = function isValid() {
      return $scope.fromDashboard && $scope.copyToOrg && ($scope.copyOption === 'new' && $scope.newDashboardName || $scope.copyOption === 'existing' && $scope.targetDashboard || $scope.copyOption === 'replace' && $scope.targetDashboard);
    };
    $scope.copyCards = function copyCards() {
      var req = {
        copyOption: $scope.copyOption,
        fromOrgId: $scope.org.id,
        fromDashboardId: $scope.fromDashboard.id,
        toOrgId: $scope.copyToOrg.id,
        toDashboardName: $scope.newDashboardName,
        toDashboardId: $scope.targetDashboard && $scope.targetDashboard.id
      };
      $http.post(Api.url("/admintools/copy-dashboard", true), req).then(function (response) {
        $scope.cardsCopied = response.data.cardsCopied;
        $scope.complete = true;
      }, function (response) {
        var err = "Error " + response.status;
        if (response.data && response.data.message) {
          err += ": " + response.data.message;
        }
        $scope.error = err;
        $scope.complete = true;
      });
    };

    // Org typeahead
    $scope.searchApiUrl = Api.url("/organizations", true);
    $scope.searchBy = "name";
    $scope.formatSearchSuggestion = function (result) {
      return result.name;
    };
    $scope.mapSearchResults = function (data) {
      return data.results;
    };
    $scope.selectCopyToOrg = function (selectedOrg) {
      $scope.copyToOrg = selectedOrg;
      $http.get(Api.url("/organizations/" + selectedOrg.id + "/dashboards", true)).then(function (response) {
        $scope.targetDashboards = response.data.results;
      });
    };
    $controller('SearchBaseCtrl', {
      $scope: $scope
    });
  }]);
})();
